import { useWindowScroll } from 'react-use';
import { Button, BUTTON_SIZES } from 'ui/button';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';

type Props = {
  children: React.ReactNode;
};

/**
 * Button used in Sticky Page Header that shrinks once the user scrolls past the breakpoint.
 */
export const ShrinkingButton = ({
  children,
  size = BUTTON_SIZES.LARGE,
  ...props
}: React.ComponentProps<typeof Button> & Props) => {
  const { y: scrollY } = useWindowScroll();
  const navBarHeight = useNavBarHeight();
  const isPastScrollBreakpoint = scrollY > navBarHeight;

  return (
    <Button {...props} size={isPastScrollBreakpoint ? BUTTON_SIZES.SMALL : size}>
      {children}
    </Button>
  );
};
